var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeatureIncluded({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 16,
    viewBox: "0 0 22 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.12594 6.39236C2.67695 6.38844 3.09802 6.53508 3.49195 6.75994C4.44698 7.30514 5.28565 7.97719 6.08459 8.69058C6.62718 9.17508 7.15822 9.67056 7.61894 10.2215C7.72526 10.3487 7.74887 10.239 7.78789 10.1832C8.34158 9.39226 8.9189 8.61549 9.54629 7.87012C11.4121 5.65346 13.525 3.66313 16.1195 2.11842C17.6395 1.21347 19.2612 0.502948 21.0281 0.0759278C21.1666 0.0424671 21.3086 0.0128578 21.4509 0.00180858C21.7419 -0.0208195 21.8871 0.171832 21.7734 0.414458C21.712 0.545676 21.5928 0.629569 21.4719 0.709273C20.6692 1.23822 19.9177 1.82274 19.1775 2.41865C17.5174 3.75513 16.0094 5.21936 14.6418 6.80082C12.4456 9.3406 10.6919 12.1123 9.32768 15.0796C8.92834 15.9482 7.68154 16.1697 6.9697 15.4572C4.95897 13.4449 2.83349 11.5323 0.656588 9.66671C-0.121211 9.00015 -0.104353 8.21401 0.177408 7.5908C0.504544 6.86716 1.32466 6.38978 2.12594 6.39236Z",
    fill: "#1A1A1A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatureIncluded);
export default __webpack_public_path__ + "static/media/feature-included.f3e2e99573d344bd3ab50545da2f0671.svg";
export { ForwardRef as ReactComponent };